<template>
  <div class="base-navigation-buttons">
    <div
      v-for="(button, index) in visibleButtons"
      :key="index"
      @click="button.disabled ? '' : selectButton(button)"
      v-tooltip="{ content: button.tooltip, placement: 'top' }"
      class="base-navigation-buttons__btn"
      :class="{
        'is-selected': isSelected(button),
        'is-disabled': button.disabled,
      }"
    >
      <BaseIcon v-if="button.locked" name="lock" class="base-navigation-buttons__lock" />
      <slot :button="button"> </slot>
    </div>
  </div>
</template>

<script>
/*
This component can takes as much buttons as you want. To do so, pass this component an array of Object
  Ex:
  buttons: [
     {
       key: '..',
       label: '...',
       order: 1
     },
     {
       key: '..',
       label: '...',
       order: 2,
     }
   ]

*/
import BaseIcon from '@/components/base/BaseIcon';

export default {
  name: 'BaseNavigationButtons',
  components: {
    BaseIcon,
  },
  props: {
    buttons: {
      type: Array,
      required: true,
    },
    isOrdered: {
      type: Boolean,
      required: false,
      default: false,
    },
    selected: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    tooltip: {
      type: String,
      required: false,
    },
    locked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    visibleButtons() {
      return this.buttons.filter((button) => !button.hidden);
    },
  },
  methods: {
    isSelected(button) {
      return this.selected.key === button.key;
    },
    selectButton(button) {
      if (button.key === this.selected.key) return;
      this.$emit('button-clicked', button);
    },
  },
};
</script>

<style lang="scss">
.base-navigation-buttons {
  display: flex;
  gap: 4px;
  padding: 4px;
  border: 1px solid $color-border;
  border-radius: $border-radius-medium;

  &__btn {
    display: flex;
    align-items: center;
    border-radius: $border-radius-medium;
    padding: 6px 16px;
    cursor: pointer;
    transition: all 200ms ease-in;
    color: $color-bluey-gray;
    font-weight: 600;
    font-size: 14px;

    &.is-selected {
      background: $color-hover;
      color: $color-normal;

      &:hover {
        background: $color-hover;
      }
    }

    &.is-disabled {
      background: $color-neutral-pale;
      cursor: not-allowed;
    }

    &:hover {
      background: $color-neutral-pale;
      transition: all 200ms ease-in;
    }
  }

  &__lock {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }
}
</style>
